// The fixed bottom tab bars (talent BottomTabBar, fan FanTabBar) tell the
// pages above them where they are, so nothing a talent can tap ever sits
// under a bar (founder, 1.5.2 b49: Balance's Withdraw slid ~34pt — the
// home-indicator strip — under the bar on his iPhone).
//
//   --app-tabbar-h  how much of the bottom of the screen the bar covers, from
//                   its top edge down (never less than its own height).
//                   <main> pads by it, so the last row can scroll clear.
//   --app-bar-top   where the bar's top edge is drawn. One-screen pages
//                   (Balance, QR) end exactly there, instead of trusting
//                   100dvh minus the bar's height: on a phone the two can
//                   disagree by the home-indicator strip.
//
// Measured from the bar itself on everything that can move it: its size, the
// window and the visual viewport, the safe-area sync (lib/safeAreaVars), and
// coming back to the app (a hidden document gets no ResizeObserver frames —
// the same hole Header.tsx documents for --app-header-h).
import { SAFE_AREA_EVENT } from "./safeAreaVars";

export function trackTabBar(el: HTMLElement): () => void {
  const root = document.documentElement.style;
  const clear = () => {
    root.setProperty("--app-tabbar-h", "0px");
    root.removeProperty("--app-bar-top");
  };
  const measure = () => {
    const r = el.getBoundingClientRect();
    // Hidden (a desktop-width web page): no bar to clear.
    if (r.height < 1) return clear();
    root.setProperty("--app-tabbar-h", `${Math.round(Math.max(r.height, window.innerHeight - r.top))}px`);
    root.setProperty("--app-bar-top", `${Math.round(r.top)}px`);
  };
  const onVisible = () => {
    if (document.visibilityState === "visible") measure();
  };
  measure();
  const ro = new ResizeObserver(measure);
  ro.observe(el);
  const vv = window.visualViewport;
  window.addEventListener("resize", measure);
  window.addEventListener("orientationchange", measure);
  window.addEventListener(SAFE_AREA_EVENT, measure);
  vv?.addEventListener("resize", measure);
  document.addEventListener("visibilitychange", onVisible);
  return () => {
    ro.disconnect();
    window.removeEventListener("resize", measure);
    window.removeEventListener("orientationchange", measure);
    window.removeEventListener(SAFE_AREA_EVENT, measure);
    vv?.removeEventListener("resize", measure);
    document.removeEventListener("visibilitychange", onVisible);
    clear();
  };
}
